import { Component, Injector, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { EnvironmentService } from 'src/app/core/services/environment/environment.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { ApplicationContextBoundComponent } from 'src/app/shared/components';

@Component({
    selector: 'tpo-manual-lock',
    templateUrl: 'tpo-manual-lock.component.html',
    standalone: false
})
export class TpoManualLockComponent extends ApplicationContextBoundComponent implements OnDestroy {
  isTpo: boolean = false;
  srcUrl: string;

  private readonly _contextSubscription: Subscription;

  constructor(private readonly injector: Injector,
    private readonly _environmentService: EnvironmentService,
    private readonly _localStorageService: LocalStorageService) {
    super(injector);
    this.isTpo = this.applicationContext.isTpo;
    this.srcUrl = `${this._environmentService.prmgTpoFormsBaseUrl}/manuallockform?baseUrl=${this._environmentService.apiInfo.apiBaseUrl}&appId=${this.applicationContext.application.applicationId}&token=${this._localStorageService.authorizationData.token}`;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this._contextSubscription?.unsubscribe();
  }
}
